import React from "react";


import {
    NavLink
} from "react-router-dom";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import IconProfileSmBrown from "./@Icons/icon-profile-sm-brown.svg";
import IconSettingsSmBrown from "./@Icons/icon-settings-sm-brown.svg";
import IconDollarSmBrown from "./@Icons/icon-dollar-sm-brown.svg";
import IconDocumentSmBrown from "./@Icons/icon-document-sm-brown.svg";
import IconSecuritySmBrown from "./@Icons/icon-security-sm-brown.svg";
import IconLogoutSmBrown from "./@Icons/icon-logout-sm-brown.svg";


import "./index.scss";


export const UserDashboardUserMenuComponent:React.FC = () => {


    return (
        <Col xs={12} lg={3} className={'user-dashboard-user-menu'}>
            <Row className={'user-dashboard-user-menu__menu-content'}>

                <Col xs={12} className={'user-dashboard-user-menu__menu-element'}>
                    <NavLink to={'/dashboard/profile'} className={'user-dashboard-user-menu__menu-element__menu-link'}>
                        <SvgIconComponent iconSource={IconProfileSmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />
                        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Profile</span>
                    </NavLink>
                </Col>

                <Col xs={12} className={'user-dashboard-user-menu__menu-element'}>
                    <NavLink to={'/dashboard/settings'} className={'user-dashboard-user-menu__menu-element__menu-link'}>
                        <SvgIconComponent iconSource={IconSettingsSmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />
                        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Settings</span>
                    </NavLink>
                </Col>

                <Col xs={12} className={'user-dashboard-user-menu__menu-element'}>
                    <NavLink to={'/dashboard/wallet'} className={'user-dashboard-user-menu__menu-element__menu-link'}>
                        <SvgIconComponent iconSource={IconDollarSmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />
                        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Wallet</span>
                    </NavLink>
                </Col>

                {/*<Col xs={12} className={'user-dashboard-user-menu__menu-element'}>*/}
                {/*    <NavLink to={'/dashboard/documents'} className={'user-dashboard-user-menu__menu-element__menu-link'}>*/}
                {/*        <SvgIconComponent iconSource={IconDocumentSmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />*/}
                {/*        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Documents</span>*/}
                {/*    </NavLink>*/}
                {/*</Col>*/}

                <Col xs={12} className={'user-dashboard-user-menu__menu-element'}>
                    <NavLink to={'/dashboard/security'} className={'user-dashboard-user-menu__menu-element__menu-link'}>
                        <SvgIconComponent iconSource={IconSecuritySmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />
                        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Security</span>
                    </NavLink>
                </Col>

                <Col xs={12} className={'user-dashboard-user-menu__menu-element'}>
                    <span className={'user-dashboard-user-menu__menu-element__menu-link'}>
                        <SvgIconComponent iconSource={IconLogoutSmBrown} className={'user-dashboard-user-menu__menu-element__menu-link__link-icon'} />
                        <span className={'user-dashboard-user-menu__menu-element__menu-link__link-text'}>Log out</span>
                    </span>
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardUserMenuComponent;
